import axios from 'axios';

export const axiosHttp=axios.create({
    baseURL:'https://dfaadmapi.dev-sh.xyz/api',
    headers:{
        "Authorization":`Bearer ${localStorage.getItem('token')}`
    }
})

axiosHttp.interceptors.request.use((res)=>{
    console.log("the res is",res)
    if(res){

        res.headers.Authorization="Bearer " +localStorage.getItem('token');
    }
    
    return res;
},(err)=>{
    console.log("intercepter reposne",err.response.data.message)
    if(err.response.data.message==="Unauthenticated"){
    
       
      localStorage.removeItem('token');
     

    }
    throw err
})